import type { DatasetResource, PaginationParams } from "@prequel/import-react";
import { useImportContext } from "@prequel/import-react";

import { useAllPages } from "@/api/pagination";

export type { DatasetResource } from "@prequel/import-react";

const keys = { all: ["import", "datasets"] as const };

export function useAllDatasets() {
  const { datasets } = useImportContext();

  return useAllPages<DatasetResource>([...keys.all], (params: PaginationParams) => datasets.list(params));
}
